export interface Restaurant {
  id: string
  name: string
  description: string
  cuisine: string
  location: string
  coordinates: [number, number]
  thumbnail: string
  rating: number
  priceRange: string
  pricePerPax: number
  availableSeats: number
  totalSeats: number
  specialPackages: string[]
  dietaryOptions: string[]
  seatingType: string
  images: string[]
  reviews: number
  phone: string
  iftarTime: string
  tables: Array<{
    id: number
    seats: number
    available: number
  }>
  menus: {
    daily: Array<{
      day: number
      date: string
      dayOfWeek: string
      starters: string[]
      mainCourse: string[]
      desserts: string[]
      shortEats: string[]
      beverages: string[]
      image: string
    }>
  }
  promotion?: {
    title: string
    description: string
    luckyDraw: string
  }
  amenities: string[]
}
export const restaurants: Restaurant[] = [
  {
    id: '1',
    name: 'The Spice Garden',
    description:
      'Authentic Maldivian cuisine with a modern twist. Experience the finest Iftar buffet featuring traditional dishes prepared by our award-winning chefs.',
    cuisine: 'Maldivian',
    location: 'Malé City Center',
    coordinates: [4.1755, 73.5093],
    thumbnail:
      'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=800',
    rating: 4.8,
    priceRange: '$$$',
    pricePerPax: 450,
    availableSeats: 45,
    totalSeats: 60,
    specialPackages: ['Ramadan Iftar Special'],
    dietaryOptions: ['Halal', 'Vegetarian'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1200',
      'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200',
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200',
    ],
    reviews: 124,
    phone: '+960 123-4567',
    iftarTime: '18:30',
    tables: [
      { id: 1, seats: 4, available: 3 },
      { id: 2, seats: 6, available: 2 },
      { id: 3, seats: 8, available: 1 },
      { id: 4, seats: 2, available: 5 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Premium Medjool Dates with Almonds',
            'Fresh Fruit Platter (Watermelon, Grapes, Dates)',
            'Traditional Harira Soup',
            'Lentil Soup with Lemon',
            'Vegetable Samosas with Mint Chutney',
            'Chicken Spring Rolls',
            'Mixed Pakoras (Onion, Potato, Spinach)',
          ],
          mainCourse: [
            'Lamb Biryani with Raita',
            'Grilled Hammour Fish with Herbs',
            'Chicken Tikka Masala',
            'Beef Kofta with Tomato Sauce',
            'Vegetable Korma',
            'Butter Chicken',
            'Prawn Curry',
            'Mixed Grill Platter',
            'Pasta Alfredo',
            'Fried Rice with Vegetables',
          ],
          desserts: [
            'Kunafa with Pistachio',
            'Baklava Assortment',
            'Traditional Falooda',
            'Umm Ali (Bread Pudding)',
            'Fresh Fruit Salad',
            'Chocolate Mousse',
            'Vanilla Ice Cream',
            'Maldivian Bondi (Coconut Cake)',
          ],
          shortEats: [
            'Bajiya (Fish Pastry)',
            'Keemia (Fish Rolls)',
            'Kulhi Boakibaa (Fish Cake)',
            'Masroshi (Tuna Flatbread)',
            'Gulha (Fish Balls)',
            'Hedhikaa Mix Platter',
            'Mini Quiches',
            'Cheese Sambusas',
          ],
          beverages: [
            'Fresh Laban (Yogurt Drink)',
            'Jallab (Date Syrup Drink)',
            'Fresh Mango Juice',
            'Watermelon Juice',
            'Traditional Raa (Toddy)',
            'Mint Lemonade',
            'Arabic Coffee',
            'Karak Chai',
          ],
          image:
            'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800',
        },
        {
          day: 2,
          date: 'March 13, 2024',
          dayOfWeek: 'Wednesday',
          starters: [
            'Dates with Honey and Walnuts',
            'Seasonal Fruit Selection',
            'Chicken Corn Soup',
            'Cream of Mushroom Soup',
            'Fish Cutlets',
            'Vegetable Spring Rolls',
            'Crispy Onion Bhaji',
          ],
          mainCourse: [
            'Chicken Biryani',
            'Grilled Tuna Steak',
            'Lamb Rogan Josh',
            'Prawn Masala',
            'Paneer Butter Masala',
            'Beef Stroganoff',
            'Fish Curry Maldivian Style',
            'Vegetable Jalfrezi',
            'Garlic Naan',
            'Saffron Rice',
          ],
          desserts: [
            'Basbousa',
            'Date Pudding',
            'Mango Kulfi',
            'Chocolate Lava Cake',
            'Rice Pudding',
            'Fresh Fruit Tart',
            'Strawberry Ice Cream',
            'Coconut Macaroons',
          ],
          shortEats: [
            'Tuna Rolls',
            'Fish Fingers',
            'Vegetable Cutlets',
            'Chicken Nuggets',
            'Cheese Balls',
            'Mini Pizzas',
            'Garlic Bread',
            'Spinach Puffs',
          ],
          beverages: [
            'Rose Milk',
            'Fresh Orange Juice',
            'Lime Mint Cooler',
            'Coconut Water',
            'Cardamom Tea',
            'Iced Coffee',
            'Pomegranate Juice',
            'Buttermilk',
          ],
          image:
            'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=800',
        },
        {
          day: 3,
          date: 'March 14, 2024',
          dayOfWeek: 'Thursday',
          starters: [
            'Stuffed Dates with Cream Cheese',
            'Tropical Fruit Medley',
            'Tom Yum Soup',
            'French Onion Soup',
            'Prawn Tempura',
            'Chicken Satay',
            'Vegetable Samosas',
          ],
          mainCourse: [
            'Mutton Biryani',
            'Grilled Salmon with Lemon Butter',
            'Chicken Korma',
            'Beef Kebabs',
            'Dal Makhani',
            'Seafood Paella',
            'Maldivian Fish Curry',
            'Mushroom Risotto',
            'Butter Naan',
            'Jeera Rice',
          ],
          desserts: [
            'Turkish Delight',
            'Gulab Jamun',
            'Tiramisu',
            'Panna Cotta',
            'Carrot Halwa',
            'Cheesecake',
            'Pistachio Ice Cream',
            'Honey Cake',
          ],
          shortEats: [
            'Chicken Wings',
            'Fish Cakes',
            'Potato Wedges',
            'Corn Fritters',
            'Cheese Sticks',
            'Mini Burgers',
            'Breadsticks',
            'Stuffed Mushrooms',
          ],
          beverages: [
            'Mango Lassi',
            'Fresh Apple Juice',
            'Mint Lemonade',
            'Coconut Shake',
            'Masala Tea',
            'Cold Coffee',
            'Watermelon Juice',
            'Yogurt Drink',
          ],
          image:
            'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
        },
        {
          day: 4,
          date: 'March 15, 2024',
          dayOfWeek: 'Friday',
          starters: [
            'Dates with Tahini',
            'Fresh Cut Fruits',
            'Minestrone Soup',
            'Sweet Corn Soup',
            'Chicken Pakoras',
            'Vegetable Tempura',
            'Fish Samosas',
          ],
          mainCourse: [
            'Prawn Biryani',
            'Grilled Chicken Breast',
            'Lamb Curry',
            'Beef Rendang',
            'Palak Paneer',
            'Lobster Thermidor',
            'Tuna Steak',
            'Vegetable Biryani',
            'Garlic Naan',
            'Coconut Rice',
          ],
          desserts: [
            'Baklava',
            'Rasmalai',
            'Chocolate Fondant',
            'Crème Brûlée',
            'Kheer',
            'Fruit Pavlova',
            'Mango Ice Cream',
            'Walnut Brownies',
          ],
          shortEats: [
            'Chicken Tenders',
            'Tuna Patties',
            'Onion Rings',
            'Vegetable Fritters',
            'Mozzarella Sticks',
            'Mini Tacos',
            'Focaccia',
            'Spinach Rolls',
          ],
          beverages: [
            'Strawberry Smoothie',
            'Fresh Grape Juice',
            'Cucumber Mint Water',
            'Fresh Coconut',
            'Ginger Tea',
            'Espresso',
            'Pineapple Juice',
            'Salted Lassi',
          ],
          image:
            'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800',
        },
        {
          day: 5,
          date: 'March 16, 2024',
          dayOfWeek: 'Saturday',
          starters: [
            'Dates with Pistachios',
            'Exotic Fruit Platter',
            'Hot and Sour Soup',
            'Cream of Tomato Soup',
            'Spring Rolls',
            'Chicken Dumplings',
            'Vegetable Pakoras',
          ],
          mainCourse: [
            'Chicken Mandi',
            'Grilled Sea Bass',
            'Mutton Korma',
            'Prawn Curry',
            'Chana Masala',
            'Beef Steak',
            'Fish Fry',
            'Mixed Vegetable Curry',
            'Cheese Naan',
            'Lemon Rice',
          ],
          desserts: [
            'Kunafa',
            'Jalebi',
            'Opera Cake',
            'Mango Mousse',
            'Gajar Halwa',
            'Apple Pie',
            'Vanilla Bean Ice Cream',
            'Coconut Barfi',
          ],
          shortEats: [
            'Crispy Chicken',
            'Fish Rolls',
            'French Fries',
            'Corn Dogs',
            'Cheese Quesadillas',
            'Mini Hot Dogs',
            'Garlic Knots',
            'Vegetable Wontons',
          ],
          beverages: [
            'Banana Shake',
            'Fresh Carrot Juice',
            'Lemon Iced Tea',
            'Tender Coconut Water',
            'Cinnamon Tea',
            'Cappuccino',
            'Mixed Berry Juice',
            'Mint Yogurt Drink',
          ],
          image:
            'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
        },
        {
          day: 6,
          date: 'March 17, 2024',
          dayOfWeek: 'Sunday',
          starters: [
            'Stuffed Dates',
            'Fresh Fruit Bowl',
            'Mulligatawny Soup',
            'Pumpkin Soup',
            'Chicken Kebabs',
            'Vegetable Rolls',
            'Fish Fingers',
          ],
          mainCourse: [
            'Lamb Kabsa',
            'Grilled Prawns',
            'Chicken Tikka',
            'Beef Biryani',
            'Aloo Gobi',
            'Seafood Platter',
            'Maldivian Garudhiya',
            'Paneer Tikka Masala',
            'Tandoori Roti',
            'Vegetable Pulao',
          ],
          desserts: [
            'Luqaimat',
            'Kulfi Falooda',
            'Black Forest Cake',
            'Lemon Tart',
            'Moong Dal Halwa',
            'Berry Cheesecake',
            'Chocolate Ice Cream',
            'Date Cookies',
          ],
          shortEats: [
            'Buffalo Wings',
            'Tuna Sandwiches',
            'Hash Browns',
            'Vegetable Tempura',
            'Cheese Nachos',
            'Mini Wraps',
            'Breadsticks with Dip',
            'Mushroom Caps',
          ],
          beverages: [
            'Papaya Smoothie',
            'Fresh Beetroot Juice',
            'Peach Iced Tea',
            'King Coconut',
            'Earl Grey Tea',
            'Latte',
            'Passion Fruit Juice',
            'Sweet Lassi',
          ],
          image:
            'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800',
        },
        {
          day: 7,
          date: 'March 18, 2024',
          dayOfWeek: 'Monday',
          starters: [
            'Dates with Almonds and Honey',
            'Assorted Fresh Fruits',
            'Lentil Soup',
            'Vegetable Soup',
            'Shrimp Tempura',
            'Chicken Rolls',
            'Mixed Pakoras',
          ],
          mainCourse: [
            'Chicken Majboos',
            'Grilled Hammour',
            'Lamb Shank',
            'Prawn Biryani',
            'Dal Tadka',
            'Beef Bourguignon',
            'Tuna Curry',
            'Vegetable Korma',
            'Butter Naan',
            'Basmati Rice',
          ],
          desserts: [
            'Qatayef',
            'Shahi Tukda',
            'Red Velvet Cake',
            'Fruit Salad',
            'Besan Ladoo',
            'Lemon Meringue Pie',
            'Cookies and Cream Ice Cream',
            'Pistachio Baklava',
          ],
          shortEats: [
            'Popcorn Chicken',
            'Fish Tacos',
            'Curly Fries',
            'Spring Rolls',
            'Cheese Poppers',
            'Mini Calzones',
            'Garlic Toast',
            'Stuffed Peppers',
          ],
          beverages: [
            'Mixed Fruit Smoothie',
            'Fresh Spinach Juice',
            'Hibiscus Tea',
            'Fresh Coconut Shake',
            'Green Tea',
            'Mocha',
            'Guava Juice',
            'Chaas',
          ],
          image:
            'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
        },
      ],
    },
    promotion: {
      title: '20% off for groups of 6+',
      description:
        'Book a table for 6 or more people and enjoy 20% discount on your total bill',
      luckyDraw: 'Daily lucky draw - Win dinner for 2 every week',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Kids Menu',
    ],
  },
  {
    id: '2',
    name: 'Ocean View Café',
    description:
      'Seafood specialties with stunning ocean views. Enjoy fresh catches prepared with traditional Maldivian spices in a serene beachfront setting.',
    cuisine: 'Seafood',
    location: 'Hulhumalé',
    coordinates: [4.2175, 73.5361],
    thumbnail:
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
    rating: 4.6,
    priceRange: '$$',
    pricePerPax: 380,
    availableSeats: 32,
    totalSeats: 50,
    specialPackages: ['Weekend Brunch', 'Ramadan Iftar Special'],
    dietaryOptions: ['Halal', 'Gluten-Free'],
    seatingType: 'outdoor',
    images: [
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200',
      'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1200',
      'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=1200',
    ],
    reviews: 98,
    phone: '+960 234-5678',
    iftarTime: '18:45',
    tables: [
      { id: 1, seats: 4, available: 4 },
      { id: 2, seats: 6, available: 3 },
      { id: 3, seats: 2, available: 6 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Fresh Dates with Honey',
            'Tropical Fruit Selection',
            'Seafood Soup with Coconut',
            'Vegetable Clear Soup',
            'Fish Samosas',
            'Prawn Tempura',
            'Vegetable Fritters',
          ],
          mainCourse: [
            'Grilled Tuna Steak',
            'Maldivian Fish Curry (Mas Riha)',
            'Garlic Butter Prawns',
            'Seafood Biryani',
            'Grilled Lobster Tail',
            'Fish Mas Huni',
            'Coconut Rice with Curry',
            'Prawn Fried Rice',
          ],
          desserts: [
            'Coconut Pudding',
            'Tropical Fruit Tart',
            'Mango Sticky Rice',
            'Panna Cotta',
            'Fresh Fruit Platter',
            'Chocolate Lava Cake',
          ],
          shortEats: [
            'Fish Rolls',
            'Tuna Cutlets',
            'Prawn Crackers',
            'Coconut Roshi',
            'Fish Cakes',
          ],
          beverages: [
            'Fresh Coconut Water',
            'Mango Lassi',
            'Lime Juice',
            'Watermelon Juice',
            'Mint Tea',
            'Arabic Coffee',
          ],
          image:
            'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
        },
      ],
    },
    promotion: {
      title: 'Seafood Lover Special',
      description:
        'Get a complimentary seafood appetizer with every Iftar booking',
      luckyDraw: 'Win a free weekend brunch for 4',
    },
    amenities: [
      'Beachfront',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Outdoor Seating',
    ],
  },
  {
    id: '3',
    name: 'Royal Tandoor',
    description:
      'Experience authentic North Indian cuisine with our clay oven specialties. From tandoori delights to rich curries, every dish tells a story of tradition.',
    cuisine: 'Indian',
    location: 'Malé City Center',
    coordinates: [4.1765, 73.5103],
    thumbnail:
      'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800',
    rating: 4.7,
    priceRange: '$$',
    pricePerPax: 350,
    availableSeats: 38,
    totalSeats: 55,
    specialPackages: ['Ramadan Iftar Special', 'Family Package'],
    dietaryOptions: ['Halal', 'Vegetarian', 'Vegan'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1200',
      'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200',
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    ],
    reviews: 156,
    phone: '+960 345-6789',
    iftarTime: '18:30',
    tables: [
      { id: 1, seats: 4, available: 5 },
      { id: 2, seats: 6, available: 2 },
      { id: 3, seats: 2, available: 4 },
      { id: 4, seats: 8, available: 1 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Dates and Dried Fruits',
            'Samosa Chaat',
            'Chicken Tikka',
            'Paneer Tikka',
            'Vegetable Pakora',
            'Onion Bhaji',
            'Mulligatawny Soup',
          ],
          mainCourse: [
            'Chicken Biryani',
            'Mutton Rogan Josh',
            'Butter Chicken',
            'Palak Paneer',
            'Dal Makhani',
            'Tandoori Chicken',
            'Fish Tikka Masala',
            'Vegetable Korma',
            'Naan and Roti',
            'Jeera Rice',
          ],
          desserts: [
            'Gulab Jamun',
            'Rasmalai',
            'Kheer',
            'Gajar Halwa',
            'Kulfi',
            'Jalebi',
          ],
          shortEats: [
            'Aloo Tikki',
            'Papdi Chaat',
            'Dahi Vada',
            'Pani Puri',
            'Kachori',
          ],
          beverages: [
            'Mango Lassi',
            'Sweet Lassi',
            'Masala Chai',
            'Fresh Lime Soda',
            'Rose Sherbet',
            'Jaljeera',
          ],
          image:
            'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800',
        },
      ],
    },
    promotion: {
      title: 'Tandoor Special',
      description: 'Free tandoori appetizer platter with bookings of 4 or more',
      luckyDraw: 'Win a cooking class with our head chef',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Private Dining',
    ],
  },
  {
    id: '4',
    name: 'Mediterranean Breeze',
    description:
      'Savor the flavors of the Mediterranean coast with our exquisite selection of Greek, Turkish, and Lebanese dishes in an elegant setting.',
    cuisine: 'Mediterranean',
    location: 'Vilimalé',
    coordinates: [4.1825, 73.4993],
    thumbnail:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=800',
    rating: 4.9,
    priceRange: '$$$$',
    pricePerPax: 520,
    availableSeats: 28,
    totalSeats: 40,
    specialPackages: ['Ramadan Iftar Special', 'Couples Special'],
    dietaryOptions: ['Halal', 'Vegetarian', 'Gluten-Free'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=1200',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    ],
    reviews: 89,
    phone: '+960 456-7890',
    iftarTime: '18:30',
    tables: [
      { id: 1, seats: 2, available: 6 },
      { id: 2, seats: 4, available: 3 },
      { id: 3, seats: 6, available: 2 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Medjool Dates with Walnuts',
            'Mezze Platter',
            'Hummus with Olive Oil',
            'Baba Ganoush',
            'Falafel',
            'Greek Salad',
            'Lentil Soup',
          ],
          mainCourse: [
            'Lamb Shawarma',
            'Chicken Kebab',
            'Grilled Sea Bass',
            'Moussaka',
            'Stuffed Vine Leaves',
            'Lamb Kofta',
            'Seafood Paella',
            'Vegetarian Tagine',
            'Turkish Pide',
            'Saffron Rice Pilaf',
          ],
          desserts: [
            'Baklava Selection',
            'Turkish Delight',
            'Kunafa',
            'Greek Yogurt with Honey',
            'Halva',
            'Pistachio Ice Cream',
          ],
          shortEats: [
            'Spanakopita',
            'Cheese Borek',
            'Kibbeh',
            'Sambousek',
            'Lahmacun',
          ],
          beverages: [
            'Turkish Coffee',
            'Mint Tea',
            'Ayran',
            'Fresh Pomegranate Juice',
            'Lemonade with Rose Water',
            'Arabic Coffee',
          ],
          image:
            'https://images.unsplash.com/photo-1544025162-d76694265947?w=800',
        },
      ],
    },
    promotion: {
      title: 'Mediterranean Night',
      description: 'Complimentary mezze platter with every Iftar reservation',
      luckyDraw: 'Win a romantic dinner for two on our rooftop',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Valet Parking',
      'Live Music',
      'Rooftop Dining',
    ],
  },
  {
    id: '5',
    name: 'Asian Fusion House',
    description:
      'A culinary journey through Asia. Experience the perfect blend of Thai, Chinese, and Japanese flavors in contemporary presentations.',
    cuisine: 'Asian Fusion',
    location: 'Hulhumalé',
    coordinates: [4.2185, 73.5371],
    thumbnail:
      'https://images.unsplash.com/photo-1547592180-85f173990554?w=800',
    rating: 4.5,
    priceRange: '$$$',
    pricePerPax: 420,
    availableSeats: 42,
    totalSeats: 60,
    specialPackages: ['Ramadan Iftar Special', 'Sushi Night'],
    dietaryOptions: ['Halal', 'Vegetarian', 'Gluten-Free'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1547592180-85f173990554?w=1200',
      'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200',
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1200',
    ],
    reviews: 112,
    phone: '+960 567-8901',
    iftarTime: '18:45',
    tables: [
      { id: 1, seats: 4, available: 4 },
      { id: 2, seats: 6, available: 3 },
      { id: 3, seats: 2, available: 7 },
      { id: 4, seats: 8, available: 1 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Fresh Dates and Nuts',
            'Spring Rolls',
            'Gyoza Dumplings',
            'Tom Yum Soup',
            'Miso Soup',
            'Edamame',
            'Chicken Satay',
          ],
          mainCourse: [
            'Pad Thai',
            'Chicken Teriyaki',
            'Beef Rendang',
            'Sushi Platter',
            'Green Curry Chicken',
            'Sweet and Sour Fish',
            'Mongolian Beef',
            'Vegetable Stir Fry',
            'Fried Rice',
            'Noodle Selection',
          ],
          desserts: [
            'Mango Sticky Rice',
            'Green Tea Ice Cream',
            'Mochi Selection',
            'Fried Banana',
            'Coconut Panna Cotta',
            'Lychee Sorbet',
          ],
          shortEats: [
            'Prawn Crackers',
            'Crispy Wontons',
            'Chicken Bao',
            'Tempura Vegetables',
            'Mini Spring Rolls',
          ],
          beverages: [
            'Thai Iced Tea',
            'Green Tea',
            'Lychee Juice',
            'Mango Lassi',
            'Fresh Lime Soda',
            'Jasmine Tea',
          ],
          image:
            'https://images.unsplash.com/photo-1547592180-85f173990554?w=800',
        },
      ],
    },
    promotion: {
      title: 'Fusion Feast',
      description: 'Free sushi roll with every Iftar booking',
      luckyDraw: 'Win a private cooking demonstration',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Sushi Bar',
      'Private Rooms',
    ],
  },
  {
    id: '6',
    name: 'La Bella Italia',
    description:
      'Authentic Italian cuisine crafted with passion. From handmade pasta to wood-fired pizzas, taste the essence of Italy.',
    cuisine: 'Italian',
    location: 'Malé City Center',
    coordinates: [4.1745, 73.5083],
    thumbnail:
      'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800',
    rating: 4.6,
    priceRange: '$$$',
    pricePerPax: 480,
    availableSeats: 35,
    totalSeats: 48,
    specialPackages: ['Ramadan Iftar Special', 'Wine & Dine'],
    dietaryOptions: ['Halal', 'Vegetarian', 'Gluten-Free'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    ],
    reviews: 134,
    phone: '+960 678-9012',
    iftarTime: '18:30',
    tables: [
      { id: 1, seats: 2, available: 5 },
      { id: 2, seats: 4, available: 4 },
      { id: 3, seats: 6, available: 2 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Dates with Parmesan',
            'Bruschetta',
            'Caprese Salad',
            'Minestrone Soup',
            'Arancini',
            'Calamari Fritti',
            'Antipasto Platter',
          ],
          mainCourse: [
            'Margherita Pizza',
            'Spaghetti Carbonara',
            'Lasagna Bolognese',
            'Chicken Parmigiana',
            'Seafood Risotto',
            'Penne Arrabbiata',
            'Osso Buco',
            'Mushroom Ravioli',
            'Grilled Salmon',
            'Garlic Bread',
          ],
          desserts: [
            'Tiramisu',
            'Panna Cotta',
            'Cannoli',
            'Gelato Selection',
            'Affogato',
            'Chocolate Fondant',
          ],
          shortEats: [
            'Focaccia',
            'Breadsticks',
            'Olive Tapenade',
            'Cheese Crostini',
            'Fried Mozzarella',
          ],
          beverages: [
            'Italian Soda',
            'Espresso',
            'Cappuccino',
            'Fresh Lemonade',
            'Sparkling Water',
            'Iced Coffee',
          ],
          image:
            'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800',
        },
      ],
    },
    promotion: {
      title: 'Italian Night',
      description: 'Free tiramisu with every Iftar reservation',
      luckyDraw: 'Win a pasta-making class for two',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Pizza Oven',
      'Wine Cellar',
    ],
  },
  {
    id: '7',
    name: 'Spice Route',
    description:
      'Embark on a flavorful journey along the ancient spice routes. Featuring Sri Lankan and South Indian specialties with aromatic spices.',
    cuisine: 'Sri Lankan',
    location: 'Vilimalé',
    coordinates: [4.1835, 73.4983],
    thumbnail:
      'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=800',
    rating: 4.4,
    priceRange: '$$',
    pricePerPax: 320,
    availableSeats: 48,
    totalSeats: 65,
    specialPackages: ['Ramadan Iftar Special', 'Lunch Buffet'],
    dietaryOptions: ['Halal', 'Vegetarian', 'Vegan'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=1200',
      'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200',
      'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1200',
    ],
    reviews: 87,
    phone: '+960 789-0123',
    iftarTime: '18:45',
    tables: [
      { id: 1, seats: 4, available: 6 },
      { id: 2, seats: 6, available: 3 },
      { id: 3, seats: 2, available: 8 },
      { id: 4, seats: 8, available: 2 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Dates and Cashews',
            'Vegetable Cutlets',
            'Fish Cutlets',
            'Lentil Soup',
            'Coconut Sambol',
            'Papadum',
            'Vegetable Samosas',
          ],
          mainCourse: [
            'Chicken Curry',
            'Fish Ambul Thiyal',
            'Dhal Curry',
            'Devilled Chicken',
            'Prawn Curry',
            'Beef Badun',
            'Vegetable Kottu',
            'Egg Hoppers',
            'String Hoppers',
            'Rice and Curry',
          ],
          desserts: [
            'Watalappan',
            'Coconut Pancakes',
            'Kiri Pani',
            'Curd with Treacle',
            'Banana Fritters',
            'Caramel Pudding',
          ],
          shortEats: [
            'Isso Vadai',
            'Ulundu Vadai',
            'Patties',
            'Rolls',
            'Kavum',
          ],
          beverages: [
            'Ceylon Tea',
            'King Coconut Water',
            'Ginger Tea',
            'Lime Juice',
            'Faluda',
            'Wood Apple Juice',
          ],
          image:
            'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=800',
        },
      ],
    },
    promotion: {
      title: 'Spice Special',
      description: 'Free appetizer platter with groups of 5 or more',
      luckyDraw: 'Win a spice collection hamper',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Family Friendly',
      'Buffet Area',
    ],
  },
  {
    id: '8',
    name: 'The Golden Palace',
    description:
      'Luxury dining experience with international cuisine. An opulent setting perfect for special occasions and memorable Iftar gatherings.',
    cuisine: 'International',
    location: 'Malé City Center',
    coordinates: [4.1775, 73.5113],
    thumbnail:
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800',
    rating: 4.9,
    priceRange: '$$$$',
    pricePerPax: 580,
    availableSeats: 25,
    totalSeats: 35,
    specialPackages: [
      'Ramadan Iftar Special',
      'VIP Package',
      'Corporate Events',
    ],
    dietaryOptions: ['Halal', 'Vegetarian', 'Gluten-Free', 'Vegan'],
    seatingType: 'indoor',
    images: [
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1200',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    ],
    reviews: 76,
    phone: '+960 890-1234',
    iftarTime: '18:30',
    tables: [
      { id: 1, seats: 2, available: 3 },
      { id: 2, seats: 4, available: 2 },
      { id: 3, seats: 6, available: 2 },
      { id: 4, seats: 10, available: 1 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Premium Dates Selection',
            'Caviar Station',
            'Lobster Bisque',
            'Foie Gras',
            'Oysters on Ice',
            'Truffle Arancini',
            'Wagyu Carpaccio',
          ],
          mainCourse: [
            'Grilled Wagyu Steak',
            'Lobster Thermidor',
            'Duck Confit',
            'Chilean Sea Bass',
            'Lamb Rack',
            'Truffle Risotto',
            'Beef Wellington',
            'King Prawns',
            'Vegetarian Tasting Menu',
            'International Cheese Board',
          ],
          desserts: [
            'Chocolate Sphere',
            'Crème Brûlée',
            'Opera Cake',
            'Fruit Tart',
            'Macarons',
            'Soufflé',
            'Premium Ice Cream Selection',
          ],
          shortEats: [
            'Canapés Selection',
            'Gourmet Sliders',
            'Truffle Fries',
            'Cheese Puffs',
            'Smoked Salmon Blinis',
          ],
          beverages: [
            'Fresh Juices',
            'Specialty Mocktails',
            'Premium Coffee',
            'Herbal Teas',
            'Sparkling Water',
            'Signature Drinks',
          ],
          image:
            'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800',
        },
      ],
    },
    promotion: {
      title: 'Royal Treatment',
      description:
        'Complimentary champagne service (non-alcoholic) for all Iftar guests',
      luckyDraw: 'Win a luxury dinner experience worth MVR 2000',
    },
    amenities: [
      'Air Conditioned',
      'WiFi',
      'Prayer Room',
      'Valet Parking',
      'Private Dining Rooms',
      'Concierge',
      'Live Entertainment',
    ],
  },
  {
    id: '9',
    name: 'Sunset Grill',
    description:
      'Beachfront dining with spectacular sunset views. Specializing in grilled meats and fresh seafood with a contemporary twist.',
    cuisine: 'Grill & BBQ',
    location: 'Hulhumalé',
    coordinates: [4.2195, 73.5381],
    thumbnail:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=800',
    rating: 4.7,
    priceRange: '$$$',
    pricePerPax: 410,
    availableSeats: 40,
    totalSeats: 55,
    specialPackages: ['Ramadan Iftar Special', 'BBQ Night', 'Sunset Special'],
    dietaryOptions: ['Halal', 'Gluten-Free'],
    seatingType: 'outdoor',
    images: [
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=1200',
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
    ],
    reviews: 142,
    phone: '+960 901-2345',
    iftarTime: '18:45',
    tables: [
      { id: 1, seats: 4, available: 5 },
      { id: 2, seats: 6, available: 3 },
      { id: 3, seats: 2, available: 6 },
      { id: 4, seats: 8, available: 2 },
    ],
    menus: {
      daily: [
        {
          day: 1,
          date: 'March 12, 2024',
          dayOfWeek: 'Tuesday',
          starters: [
            'Dates with Blue Cheese',
            'Grilled Vegetable Platter',
            'BBQ Wings',
            'Garlic Prawns',
            'Corn on the Cob',
            'Caesar Salad',
            'Soup of the Day',
          ],
          mainCourse: [
            'Ribeye Steak',
            'BBQ Ribs',
            'Grilled Salmon',
            'Lamb Chops',
            'Chicken Shawarma',
            'Mixed Grill Platter',
            'Grilled Prawns',
            'Beef Burger',
            'Grilled Vegetables',
            'Steak Fries',
          ],
          desserts: [
            'Grilled Pineapple',
            'Brownie Sundae',
            'Cheesecake',
            'Apple Pie',
            'Ice Cream Selection',
            'Fruit Skewers',
          ],
          shortEats: [
            'Chicken Tenders',
            'Onion Rings',
            'Loaded Fries',
            'Chicken Sliders',
            'Fish Tacos',
          ],
          beverages: [
            'Fresh Lemonade',
            'Iced Tea',
            'Tropical Smoothies',
            'Fresh Juices',
            'Mocktails',
            'Coffee',
          ],
          image:
            'https://images.unsplash.com/photo-1544025162-d76694265947?w=800',
        },
      ],
    },
    promotion: {
      title: 'Sunset Special',
      description: 'Book before 6 PM and get a free appetizer',
      luckyDraw: 'Win a sunset cruise dinner for two',
    },
    amenities: [
      'Beachfront',
      'WiFi',
      'Prayer Room',
      'Parking',
      'Outdoor Seating',
      'Live Grill Station',
      'Sunset Views',
    ],
  },
]
